import React from "react";

import { Box, Typography } from "@mui/material";
import { withStyles } from "tss-react/mui";

import { theme } from "@/theme/customTheme";
import KcalIcon from "@components/Icons/KcalIcon";

const StyledKcalIcon = withStyles(KcalIcon, {
  root: {
    marginRight: theme.spacing(2),
    width: "18px",
    height: "18px",
  },
});

type RecommendedCaloriesProps = {
  recommendedCalories: number | undefined;
};

const RecommendedCalories: React.FC<RecommendedCaloriesProps> = ({
  recommendedCalories,
}) => {
  return (
    <Box display="flex" flexDirection="row" alignItems="center" flexWrap="wrap">
      <StyledKcalIcon />
      <Typography variant="h6" color="textPrimary">
        {recommendedCalories ?? "N/A"}
      </Typography>
      <Typography
        variant="subtitle1"
        color="textSecondary"
        style={{ marginLeft: theme.spacing(2) }}
      >
        {recommendedCalories != undefined ? "kcal" : ""}
      </Typography>
    </Box>
  );
};

export default RecommendedCalories;
